import React from 'react';
import {getMaterialsMap} from "./model/data";
import {numberWithCommas} from "./util";
import {globalSettings} from "./config";

export class LogisticsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materialsMap: {}
    }
  }

  componentDidMount() {
    getMaterialsMap((newMaterialsMap) => {
      this.setState({
        materialsMap: newMaterialsMap,
        materialsMapLoaded: true,
      })
    })
  }

  render() {
    return <div className={"container"}>
      <table className={"table"}>
        <thead>
        <tr>
          <th></th>
          <th>Material</th>
          <th>Inventory</th>
          <th>Target</th>
          {Object.keys(globalSettings.locations).map((location) => {
            return <th key={location}>
              <div>{location}</div>
              <select className={"form-control"}>
                <option value="">-</option>
                <option value="origin">Origin</option>
                <option value="destination">Destination</option>
              </select>
            </th>
          })}
        </tr>
        </thead>
        <tbody>
        {Object.keys(this.state.materialsMap).map(name => {
          let material = this.state.materialsMap[name];
          if (material.type === "ore") {
            return null;
          }
          if (material.totalTargetInventory == 0) {
            return null;
          }
          return <tr key={name}>
            <th><input type="checkbox"/></th>
            <th>{material.name}</th>
            <td>{numberWithCommas(material.totalInventory)}</td>
            <td>{numberWithCommas(material.totalTargetInventory)}</td>
            {Object.keys(globalSettings.locations).map((location) => {
              return <td key={location}>{numberWithCommas(material.inventory[location] || 0)}</td>
            })}
          </tr>
        })}
        </tbody>
      </table>
    </div>
  }
}